import { useAppUser } from "@/application/composables/useAppUser.ts";

export function hideForShallowUserClass() {
    return useAppUser().isShallow() ? '!hidden' : ''
}
